import { BaseSchema_PetHealthV2GetsafeDe as schema } from '@flows/insurance/schemas'

export const PET_HEALTH_V2_PRODUCT_KEY = 'pet_health_v2_getsafe_de' as const

export const UNKNOWN_BREED_OPTION = 'unknown'

export const BREED_IMAGE_COLLECTION = 'petPortraits'

export const MIN_ENTRY_AGE_WEEKS = 8

const BREED_PARAMS = ['first_breed_name', 'second_breed_name'] as const

export const MAX_CROSS_BREEDS = BREED_PARAMS.length

export const SHOULDER_HEIGHT_OPTIONS = schema.shape.shoulder_height_class.unwrap().options

export const CONSENT_LEGAL_TEXT_KEYS = {
  personalConsultationWaive: 'petHealthV2PersonalConsultationWaiver',
  contractDocumentsAccepted: 'petHealthV2ContractDocuments',
  confidentialityWaiver: 'petHealthV2ConsentAndReleaseFromConfidentiality',
} as const

export const PET_HEALTH_V2_DEFAULT_CONFIGURATION_PARAMETERS = {
  tariff_type: 'surgery_coverage',
  deductible_percentage: 20,
  sum_insured: '5000',
  addon_dental: false,
  addon_sos_budget: false,
  addon_preventive_care: false,
  previous_insurance: 'unknown',
} as const

export const PET_HEALTH_V2_ALLOWED_LOOPS = [
  { stepName: 'condition_illness', nextStepName: 'pre_existing_conditions' },
] as const
